import {observable} from 'mobx';

export class NwayParticipantState {
    @observable guid: string = '';
    @observable isMini: boolean = false;
    @observable isEmb: boolean = false;
}
